import Router from "./components/routing/Router";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { FirebaseContext } from "./context/firebaseContext";

const firebaseConfig = {
  apiKey: "AIzaSyCV-U-aeiR-yBpC0AXBobNnzm2qLqG7u8s",
  authDomain: "auth.epycexplorer.com",
  projectId: "epyc-explorer-f9564",
  storageBucket: "epyc-explorer-f9564.appspot.com",
  messagingSenderId: "359333025156",
  appId: "1:359333025156:web:677ac1eb576a8d76a0f9d1",
  measurementId: "G-WX8N4PGD2S",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);

const googleAuthProvider = new GoogleAuthProvider();
googleAuthProvider.setCustomParameters({
  login_hint: "Use your @google.com or @amd.com email address.",
});

const auth = getAuth(app);
auth.useDeviceLanguage();

function App() {
  const contextValue = { db, auth, analytics, googleAuthProvider };

  return (
    <FirebaseContext.Provider value={contextValue}>
      <Router />
    </FirebaseContext.Provider>
  );
}

export default App;
